import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Config from '../../config/Config';
import { fetchInstruction } from '../../redux/myCourse/myCourse.actions';
import { getChildReport } from '../../redux/parentDashboard/parentDashboard.actions';

const FinalTest = ({
	match,
	courses,
	childrenList,
	fetchInstruction,
	childToken,
	getChildReport,
	completed,
	total_attempts,
	element_name,
	elementID,
	percentcomplete,
	element_type,
	activeCourseId,
}) => {
	const { course_id } = childrenList[match.params.id || 0];
	const [attemptsAvailable, setAttemptsAvailable] = useState(0);
	useEffect(() => {
		setAttemptsAvailable(total_attempts - completed);
	}, [total_attempts, completed]);
	return (
		<div className="dash-courses last-dash-course">
			<div className="dash-course-logo">
				<img
					src={`${Config.ASSETSPATH}img/STEPATHON_Junior.jpg`}
					alt="courseimage"
				/>
			</div>
			<div className="dash-course-decs">
				<div className="d-flex flex-row align-items-center justify-content-between">
					<div className="flex-grow-1">
						<p className="text-capitalize">{element_name}</p>
						{attemptsAvailable > 0 ? (
							<>
								<p className="dash-decs-date">
									<strong>You can attempt the final test only once.</strong>
								</p>
								<small>Test duration is 25 minutes.</small>{' '}
							</>
						) : (
							<>
								<p className="dash-decs-date">
									<strong>You have completed the test!</strong>
								</p>
								<small>Your report is ready to download.</small>{' '}
							</>
						)}
					</div>

					{element_type === 'S' && completed === total_attempts ? (
						<>
							<div className="kid-score-icon">
								<span>{courses?.final_score || 0}%</span>
							</div>
							<div className="kids-certificate" onClick={getChildReport}>
								<img src="/assets/img/chart-download-icon.svg" alt="Test name" />
							</div>{' '}
						</>
					) : (
						<div>
							<button
								onClick={() => {
									percentcomplete === 100
										? fetchInstruction(elementID, course_id, true, childToken)
										: fetchInstruction(elementID, course_id, false, childToken);
								}}
								aria-label="Start Test"
								className="btn btn-primary step-btn"
							>
								{completed === total_attempts ? 'Review' : 'Start Test'}
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		courses,
		childrenList,
		activeCourseId,
		childToken,
	} = state.rootReducer.parentDetails;
	return {
		courses,
		childrenList,
		childToken,
		activeCourseId,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchInstruction: (elementId, courseId, completed = false, childToken) =>
			dispatch(fetchInstruction({ elementId, courseId, completed, childToken })),

		getChildReport: () => dispatch(getChildReport()),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(FinalTest),
);
